module.exports = __webpack_public_path__ + "4fc791b80a3b425714d300570d2c7779.svg";